import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import values from "lodash/values";
import PersonUtil from "../utils/PersonUtil";
import PersonActions from "../actions/PersonActions";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";
import UserStore from "../stores/UserStore";

class PersonStore {
  constructor() {
    this.bindActions(PersonActions);

    this.state = {
      people: {},
      peopleAutocomplete: [],
      isFetching: false,
      isSaving: false,
      isSendingPasswordReset: false
    };

    this.exportPublicMethods({
      getPersonById: this.getPersonById.bind(this),
      getPeople: this.getPeople.bind(this),
      getPeopleAutocomplete: this.getPeopleAutocomplete.bind(this)
    });
  }

  getPersonById(id) {
    return this.state.people[id];
  }

  getPeople() {
    return values(this.state.people);
  }

  getPeopleAutocomplete() {
    return this.state.peopleAutocomplete;
  }

  onFetchAll(options) {
    this.setState({ isFetching: true });
    PersonUtil.fetchAll(UserStore.getState().apiKey, options)
      .then(data => {
        PersonActions.updatePeople(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(PersonActions.fetchFailed);
  }

  onFetchOne(id) {
    PersonUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        PersonActions.updatePerson(id, data);
      })
      .catch(PersonActions.fetchFailed);
  }

  onFetchAutocomplete(query) {
    this.setState({ isFetching: true });
    PersonUtil.fetchAutocomplete(UserStore.getState().apiKey, query)
      .then(data => {
        PersonActions.updateAutocomplete(data);
        this.setState({ isFetching: true });
      })
      .catch(PersonActions.fetchFailed);
  }

  onUpdatePerson(d) {
    this.state.people[d.id] = d.data;
    this.setState(this.state);
  }

  onUpdatePeople(data) {
    if (!data) {
      this.state.people = {};
    } else {
      this.state.people = data;
    }
    this.setState(this.state);
  }

  onUpdateAutocomplete(data) {
    if (!data) {
      this.state.peopleAutocomplete = [];
    } else {
      this.state.peopleAutocomplete = data.data.people;
    }
    this.setState(this.state);
  }

  onEdit(newData) {
    GlobalNotificationActions.notify.defer("Updating person...");
    this.setState({ isSaving: true });
    PersonUtil.edit(UserStore.getState().apiKey, newData.id, newData.values)
      .then(data => {
        this.setState({ isSaving: false });
        PersonActions.updatePerson(newData.id, data);
        GlobalNotificationActions.notify.defer("Person updated successfully.");
      })
      .catch(PersonActions.editFailed);
  }

  onCreate(newData) {
    this.setState({ isSaving: true });
    PersonUtil.create(UserStore.getState().apiKey, newData.values)
      .then(data => {
        this.setState({ isSaving: false });
        PersonActions.updatePerson(data.id, data);
        GlobalNotificationActions.notify.defer("Person created successfully.");
      })
      .catch(PersonActions.editFailed);
  }

  onForgotPassword({ id, event_bucket }) {
    this.setState({ isSendingPasswordReset: true });
    GlobalNotificationActions.notify.defer("Sending password reset email...");
    PersonUtil.forgotPassword(UserStore.getState().apiKey, id, event_bucket)
      .then(data => {
        this.setState({ isSendingPasswordReset: false });
        GlobalNotificationActions.notify.defer(
          `Password reset instructions sent successfully to "${data.email}".`
        );
      })
      .catch(e => {
        GlobalNotificationActions.notify.defer(
          `Error sending password reset instructions: ${e.message}`
        );
      });
  }

  onFetchFailed(e) {
    alert(`Fetching person failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Editing person failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(PersonStore, "PersonStore");



// WEBPACK FOOTER //
// ./src/app/stores/PersonStore.js